export default "__VITE_ASSET__BQxWjigV__"